import Icon from "@/components/units/Icon";
import "@/index.css"

import DownloadButton from '@/components/sections/DownloadButton';

export default function MainHeader({userData}) {
  
  const navigateToDashboard = () => {
    window.location.href = `${import.meta.env.VITE_APP_URL}/dashboard`
  };

  const navigateToProfile = () => {
    const profileUrl = import.meta.env.VITE_APP_URL + "/dashboard/account"
    window.location.href = profileUrl
  }

  return (
    <div className="tw-flex tw-justify-center tw-h-12 tw-bg-gradient-to-b tw-from-[#001316] tw-to-[#051F23] tw-w-full">
      <div className="tw-flex tw-justify-between tw-items-center tw-w-[95%] tw-flex-1">
        <Icon iconName="logo" onClick={navigateToDashboard}/>
        <div className="tw-p-4 tw-flex tw-gap-2">
          <DownloadButton/>
          <div onClick={navigateToProfile} className="tw-cursor-pointer tw-rounded-full hover:tw-bg-[#343434]">
            { userData?.initials ?
              (
                <div className="tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-border-solid tw-border tw-border-[#75FFFF1A] tw-rounded-full tw-text-base tw-text-white">
                  { userData?.initials }
                </div>
              )
              : <Icon iconName="profile" onClick={() => {}}/>
          }
          </div>
        </div>
      </div>
    </div>
  );
}
